import styled from '@emotion/styled';
import { ChevronIcon } from 'src/domains/layouts/shared/assets/icons/ChevronIcon';
import { Link } from 'src/domains/layouts/webview/components/router/NewLink';
import { withConfig } from 'src/withConfig';

export const CardFooterListItem = withConfig(theme => styled('div', { label: 'CardFooterListItem' })`
    align-items: center;
    background-color: ${theme.star.selectionsGroup.bgColor};
    border-bottom: 1px solid ${theme.star.racingNextOff.raceBox.borderColor};
    display: flex;
    flex-flow: row nowrap;
    height: 40px;
    justify-content: space-between;
    padding: 12px;
`);

export const ShowMoreLink = withConfig(theme => styled(Link, { label: 'ShowMoreLink' })`
    color: ${theme.star.racingNextOff.raceBox.txtColor};
    display: flex;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    gap: 4px;
    line-height: 1.3334;
    text-decoration: none;
    text-transform: capitalize;
`);

export const ShowMoreArrowWrapper = styled(ChevronIcon, { label: 'ShowMoreArrowWrapper' })`
    align-self: center;
    fill: currentcolor;
    position: relative;
    width: 12px;
`;
